import { useEffect, useState } from 'react'
import { getLanguageFromStorage } from '@/i18n/storage'
import { parseLanguage } from '@/i18n/utils'
import { changeLanguage } from '@/i18n/action'

const useLanguageChange = () => {
  const [selectedLang, setSelectedLang] = useState<string | null>(
    getLanguageFromStorage(),
  )

  useEffect(() => {
    if (!selectedLang) return
    changeLanguage(parseLanguage(selectedLang))
  }, [selectedLang])

  return {
    selectedLang,
    changeLanguage: setSelectedLang,
  }
}

export default useLanguageChange
